
import * as types from './mutations_types'
import {store} from '../../utils/';

export default {
	[types.update_areaOption](state, data) {
		state.areaOption = data;
	},

	[types.update_scoreItem](state, data) {
		state.scoreItem = data;
		store.set('scoreItem', state.scoreItem);
	},

  [types.update_device](state, data) {
    state.device = data;
    
  },
	
  [types.update_isCollapse](state, data) {
    state.isCollapse = data;

	},
	
	[types.update_cachedViews](state, data) {
    if (state.cachedViews.includes(data)) return
		state.cachedViews.push(data)
	},

  
};